export const META_JSON_FILE_NAME = "envx.meta.json";
export const JSON_CONFIG_FILE_NAME = "envx.config.json";
export const DEFAULT_ENV_FILE = ".env";
export const DEFAULT_ENVX_FILE = ".envx";
